import { ReactNode, useState } from "react";
import { useWatch } from "react-hook-form";
import classNames from "classnames";
import styles from "./index.module.scss";
import Comment from "../../UserInterface/Comment";
import { useStoreContext } from "../../../contexts/StoreProvider";
import { isSalesRep } from "../../../utils/user";

type PropsType = {
  section?: string;
  id: string;
  children: ReactNode | ReactNode[];
  className?: string; // className for full CommentGroup; use for padding/margin
  customPosition?: string; // className for "Comment"; use for custom positioning of the button
  commentBoxPosition?: "top" | "bottom";
  readOnly?: boolean;
  locked?: boolean;
};

const CommentGroup = ({
  section,
  id,
  children,
  className,
  customPosition,
  commentBoxPosition,
  readOnly,
  locked
}: PropsType) => {
  const {
    state: { user },
  } = useStoreContext();

  const [hover, setHover] = useState(false);
  const idDotFormat = (() => {
    if (section) {
      return `comments.${section}.${id}`;
    }
    return `${id}`;
  })();
  const commentMessage = useWatch({ name: `${idDotFormat}.message` });
  const isCommentEmpty = ["", undefined].includes(commentMessage);

  return (
    <div
      className={classNames(className, styles.commentArea, {
        [styles.yellow]: !isCommentEmpty && hover,
      })}
      onMouseOver={() => {
        setHover(true);
      }}
      onFocus={() => {
        setHover(true);
      }}
      onMouseOut={() => {
        setHover(false);
      }}
      onBlur={() => {
        setHover(false);
      }}
    >
      {(isSalesRep(user) || !isCommentEmpty) && (
        <div className={classNames(customPosition, styles.comment)}>
          <Comment
            hover={hover && !readOnly}
            setHover={setHover}
            section={section}
            id={id}
            commentBoxPosition={commentBoxPosition}
            readOnly={readOnly}
            locked={locked}
          />
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default CommentGroup;
